import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'underscore';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { SiteConfigContext } from '@bingads-webui-campaign-react/smart-page-context';
import { getComponentById } from '@bingads-webui-campaign-react/smart-component-util';

import { SmartGalleryView } from './smart-gallery-view';

export const SmartGalleryConnector = ({ id }) => {
  const i18n = useContext(I18nContext);
  const { siteConfig } = useContext(SiteConfigContext);
  const { photos } = getComponentById(siteConfig, id);

  return useMemo(() => (
    isEmpty(photos)
      ? null
      : <SmartGalleryView
        items={photos}
        i18n={i18n}
        id={id}
      />
  ), [photos, id, i18n]);
};

SmartGalleryConnector.propTypes = {
  id: PropTypes.string.isRequired,
};
